import {
  ApiPackaging,
  ApiPackagingLevelType,
  PackagingLevelKey,
  PackagingUnitFieldKey
} from "../types/packagingDetail.types";

/** Literal port of the legacy `PACKAGING_LEVELS_CONFIG` (UpdateNodes/shared/packaging) —
 * kept self-contained here rather than importing across into UpdateNodes. `unitFieldKey` is
 * the field-key vocabulary `useUpdatePackagingDetails` expects as its body's `packagingType` —
 * distinct from `apiType`, the path-style string material CRUD uses. Don't conflate the two. */
export const LEVEL_CONFIG: {
  key: PackagingLevelKey;
  apiType: ApiPackagingLevelType;
  label: string;
  unitFieldKey: PackagingUnitFieldKey;
  /** `ApiPackaging` field the backend computes this level's total weight (kg) into. */
  totalWeightKey: keyof Pick<
    ApiPackaging,
    "totalWeightBaseUnit" | "totalWeightSalesOfPack" | "totalWeightBulkPack" | "totalWeightTransportUnitPack"
  >;
}[] = [
  {
    key: "singleUnitPackaging",
    apiType: "single-unit",
    label: "Single Unit Packaging",
    unitFieldKey: "unitSize",
    totalWeightKey: "totalWeightBaseUnit"
  },
  {
    key: "salesUnitPackaging",
    apiType: "sales-unit",
    label: "Sales Unit Packaging",
    unitFieldKey: "numberOfBaseUnits",
    totalWeightKey: "totalWeightSalesOfPack"
  },
  {
    key: "bulkUnitPackaging",
    apiType: "bulk-unit",
    label: "Bulk Unit Packaging",
    unitFieldKey: "numberOfPacks",
    totalWeightKey: "totalWeightBulkPack"
  },
  {
    key: "transportUnitPackaging",
    apiType: "transport-unit",
    label: "Transport Unit Packaging",
    unitFieldKey: "numberOfCases",
    totalWeightKey: "totalWeightTransportUnitPack"
  }
];
